const movies = [
  {
    id: 1,
    title: 'Kingsglaive',
    subtitle: 'Final Fantasy XV',
    storyline: "King Regis, who oversees the land of Lucis, commands his army of soldiers to protect the kingdom from the Niflheim empire's plans to steal the sacred crystal.",
    rating: 4.5,
    imagePath: 'https://i2.wp.com/www.portallos.com.br/wp-content/uploads/2016/12/Kingsglaive-FFXV-009.jpg?fit=1200%2C675&ssl=1',
    bookmarked: true,
    genre: 'action',
  },
  {
    id: 2,
    title: 'Final Fantasy',
    subtitle: 'Spirits Within',
    storyline: 'A scientist makes a last stand on Earth with the help of a ragtag team of soldiers against an invasion of alien phantoms.',
    rating: 4.5,
    imagePath: 'https://mercury-media.cursecdn.com/attachments/4/199/final-fantasy-the-spirits-within-original.jpg',
    bookmarked: false,
    genre: 'fantasy',
  },
  {
    id: 3,
    title: 'Ghost In The Shell',
    subtitle: 'Ghost In The Shell',
    storyline: 'A hacker known as the Puppet Master is hunted by a female cyborg cop and her partner. This film is a revised version of Ghost in the Shell (1995).',
    rating: 5,
    imagePath: 'https://www.einerd.com.br/wp-content/uploads/2017/04/Ghost.jpg',
    bookmarked: false,
    genre: 'comedy',
  },
  {
    id: 4,
    title: 'Appleseed Alpha',
    subtitle: 'Appleseed Alpha',
    storyline: "A young female soldier Deunan and her cyborg partner Briareos survive through the post World War 3 apocalyptic New York in search of human's future hope, the legendary city of Olympus.",
    rating: 3.8,
    imagePath: 'https://musicart.xboxlive.com/6/cfb36573-0000-0000-0000-000000000009/504/image.jpg?w=1920&h=1080',
    bookmarked: true,
    genre: 'action',
  },
  {
    id: 5,
    title: 'Resident Evil',
    subtitle: 'Vendetta',
    storyline: 'Chris Redfield enlists the help of Leon S. Kennedy and Rebecca Chambers to stop a death merchant, with a vengeance, from spreading a deadly virus in New York.',
    rating: 4.2,
    imagePath: 'https://cdn.ome.lt/gijUu798rUAKU533ArsCajZuNWs=/970x360/smart/uploads/conteudo/fotos/resident-evil-4-header_80BpabY.jpg',
    bookmarked: true,
    genre: 'fantasy',
  },
];

export default movies;
